// extracted by mini-css-extract-plugin
module.exports = {"animation":"style_animation__sEzDm","mainContainer":"style_mainContainer__UEvk0"};